import user from "./user"
import otherApi from "./other/index.js"
import news from "./news.js"
export default {
    user,
    otherApi,
    news
}